import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'src/core/gd-components/gd-popover/popover'
import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll'
import RenderComponentProto from '../../render-component-proto'
import Checkbox from 'core/gd-components/checkbox/checkbox'
import GDButtonRemove from 'core/gd-components/buttons/gd-button-remove/gd-button-remove'
import ListMulti_getColorCodingStyle from "../functions/get-color-coding-style"

const debug = false
// const debug = "ListMultiComponentProto"

export default class ListMultiComponentProto extends RenderComponentProto {

    static propTypes = {
        id          : PropTypes.string.isRequired,
        renderMode  : PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value       : PropTypes.array,

        canEdit     : PropTypes.bool,

        onChange    : PropTypes.func,
    }

    static defaultProps = {
        value   : [],
        canEdit : false,
    }

    constructor(props) {
        super(props);

        let initValue = [];
        if (props.value && props.value.length>0) initValue = props.value;

        this.state = {
            value: initValue,
            showPopover: false,
        };

        this._bind('showPopover', 'hidePopover', 'confirmSelection', 'onOptionClick',
            'onRemoveOptionClick', 'onManageCustomField');
    }

    showPopover() {
        if (!this.state.showPopover) this.setState({showPopover: true})
    }

    hidePopover() {
        if (this.state.showPopover) this.setState({showPopover: false})
    }

    confirmSelection() {
        if (this.props.onChange) this.props.onChange(this.state.value);
    }

    onOptionClick(value, e, callback) {
        if (e) e.stopPropagation();
        const newValue = gd.utils.toggleArrayValue(this.state.value.slice(), value);
        this.setState({ value: newValue }, callback);
    }

    onRemoveOptionClick(value, e) {
        this.onOptionClick(value, e, this.confirmSelection)
    }

    onManageCustomField() {
        this.hidePopover();

        const customField = gd.session.customFields.get(this.props.id);

        gd.modals.customField.editCustomField({
            title: customField.name,
            organizationId: customField.companyId,
            customField: customField,
            callback: false //()=>{this.render()}
        });
    }

    renderOptionItems(items) {
        let content = null;

        if (items) {
            content = items.map(item => {
                const isSelected = this.state.value.includes(item.id)
                const classes = Classes('action with-icon flex-row-left-center', {
                    // selected: isSelected
                })

                const valueClasses = Classes({
                    'label'                     : !item.color,
                    'option-value ui5-pale-bg'  : !!item.color,
                    // bold                        : isSelected
                })

                const valueStyle = ListMulti_getColorCodingStyle(item)

                return (
                    <div key={item.id} className={classes} onClick={this.onOptionClick.bind(this, item.id)}>
                        <Checkbox className="action-check-box" isChecked={isSelected} size="normal-14"/>
                        <div className={valueClasses} style={valueStyle}>
                            <div className="ui5-txt-default-small">
                                {item.value}
                            </div>
                        </div>
                    </div>
                );
            });
        }

        return (
            <div className="gd-popup-menu-items">
                {content}
            </div>
        );
    }

    renderPopover() {
        if (!this.state.showPopover) return false;

        const options = this.getOptions();

        let editCustomFiled = false;
        if (gd.ac.check.customField.canEdit(this.props.id)) {
            editCustomFiled = (
                <div className="gd-popup-menu-items gray">
                    <div className="manage-action" onClick={this.onManageCustomField}>Edit options</div>
                </div>
            )
        }

        return (
            <Popover className="field-list-popover-container"
                     popoverClass="gd-field-list-multi-popover"
                     targetClass="field-holder"
                     attachment="top center"
                     targetAttachment="bottom center"
                     onClickOutside={()=>{this.hidePopover()}}
                     onPopoverHide={this.confirmSelection}>

                <VScroll className="field-list-block" scrollVisibility="auto">
                    {this.renderOptionItems(options)}

                    {editCustomFiled}

                </VScroll>
            </Popover>
        );
    }

    getOptions() {
        const cf = gd.session.customFields.get(this.props.id);
        return cf.params.listItems;
    }

    render() {
        const { value } = this.state;

        const options = this.getOptions();
        const selectedOptions = _.filter(options, o => value && value.includes(o.id));

        const pillMaxWidth = 65;
        const width = _.get(this, 'props.width', null);

        let optionsToShow, moreOptions
        if (!_.isNil(width)) {
            optionsToShow = Math.floor(width/pillMaxWidth)
            moreOptions = _.max([_.get(selectedOptions, 'length', 0) - optionsToShow, 0])
        } else {
            optionsToShow = this.props.renderMode === 'list' ? 2 : null
            moreOptions = optionsToShow && selectedOptions.length > 2 ? selectedOptions.length - 2 : null
        }

        const classes = Classes('gd-field-list-multi', this.props.renderMode,  {
            'disabled'          : this.props.canEdit === false,
            'not-set'           : !value || value.length === 0,
            'opened-popover'    : this.state.showPopover,
            'left-align'        : this.props.renderMode === 'list' && !!moreOptions
        });

        debug && console.log(debug, 'render', optionsToShow)

        return (
            <div className={classes} onClick={this.props.canEdit ? this.showPopover : null}>
                <div className="field-holder">
                    {selectedOptions.length === 0 && 'Please select'}
                    {_.map(selectedOptions, (option,key)=>{
                        if (optionsToShow && key >= optionsToShow) return;

                        debug && console.log(debug, 'render option', option)

                        const classes = Classes("selected-value", {
                            'ui5-pale-bg': !!option.color
                        })

                        const style = ListMulti_getColorCodingStyle(option)

                        return (
                            <div key        = {option.id}
                                 className  = {classes}
                                 style      = {style}>
                                <GDButtonRemove className   = "selected-value-remove-button"
                                                type        = "small"
                                                color       = "grey"
                                                onClick     = {this.onRemoveOptionClick.bind(this, option.id)} />
                                <div className="ui5-txt-default-small">
                                    {option.value}
                                </div>
                            </div>
                        );
                    })}
                    {!!moreOptions && <div className="selected-value-more">+{moreOptions}</div>}
                </div>
                {this.renderPopover()}
            </div>
        );
    }
}
